var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"statusWrap"},[_c('SettingsStatus',{attrs:{"is-loading":_vm.isLoading,"error-message":_vm.errorMessage,"success-message":_vm.successMessage}})],1),_vm._v(" "),_vm._t("default",null,{"saveSetting":_vm.debouncedSaveSetting})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }